"use strict";

import angular from "angular";

angular.module("nucont.home", ["nucont.shared"]);
require("./home.routes");
